export enum DeliveryMethodEnum {
    delivery,
    self_pickup,
    to_table,
}